import React, { Component } from 'react'
import PropTypes from 'prop-types'
import globalTheme, { sidebarWidth } from '../../theme/globalTheme'

class Drawer extends Component {
  constructor(props) {
    super(props)

    this.canvas = React.createRef()
    this.state = {
      index: 0,
      start: { x: 0, y: 0 },
      finish: { x: 0, y: 0 },
      isPainting: false,
      box: {
        width: 0,
        height: 0,
      },
    }

    this.bindMouseDown = this.bindMouseDown.bind(this)
    this.bindMouseMove = this.bindMouseMove.bind(this)
    this.bindMouseUpOut = this.bindMouseUpOut.bind(this)
    this.paintingStatus = this.paintingStatus.bind(this)
    this.paint = this.paint.bind(this)
    this.clear = this.clear.bind(this)
  }

  componentDidMount() {
    if (this.canvas.current === null) {
      return
    }

    this.canvas.current.addEventListener('mousemove', this.findXY('move'))
    this.canvas.current.addEventListener('mousedown', this.findXY('down'))
    this.canvas.current.addEventListener('mouseup', this.findXY('up'))
    this.canvas.current.addEventListener('mouseout', this.findXY('out'))
  }

  componentDidUpdate() {
    this.canvas.current.style.width = '100%'
    this.canvas.current.style.height = '100vh'
    const { width, height } = this.canvas.current.getBoundingClientRect()

    if (width !== this.state.box.width || height !== this.state.box.height) {
      this.setState({ box: { width, height } })
      this.clear()

      this.canvas.current.width = this.canvas.current.getBoundingClientRect().width
      this.canvas.current.height = this.canvas.current.getBoundingClientRect().height
    }

    if (this.state.index !== this.props.index) {
      this.setState({ index: this.props.index })
      this.clear()
    }
  }

  findXY(action) {
    switch (action) {
      case 'down':
        return this.bindMouseDown
      case 'up':
      case 'out':
        return this.bindMouseUpOut
      case 'move':
        return this.bindMouseMove
      default:
        return null
    }
  }

  bindMouseDown(event) {
    this.clear()
    this.paintingStatus()

    this.setState({
      start: {
        x:
          this.props.sidebarIsClosed === true
            ? event.clientX - this.canvas.current.offsetLeft
            : event.clientX - this.canvas.current.offsetLeft - (sidebarWidth / 100) * window.screen.availWidth,
        y: event.clientY - this.canvas.current.offsetTop,
      },
      finish: {
        x: 0,
        y: 0,
      },
    })
  }

  bindMouseUpOut() {
    this.paintingStatus(false)
  }

  bindMouseMove(event) {
    this.setState({
      finish: {
        x:
          this.props.sidebarIsClosed === true
            ? event.clientX - this.canvas.current.offsetLeft
            : event.clientX - this.canvas.current.offsetLeft - (sidebarWidth / 100) * window.screen.availWidth,
        y: this.state.start.y,
      },
    })

    if (this.state.isPainting === true) {
      this.paint()
      this.props.changeMeasurement(this.props.index, this.state.finish.x - this.state.start.x)
    }
  }

  paintingStatus(status = true) {
    this.setState({ ...this.state, isPainting: status })
  }

  paint(color = globalTheme.drawer.color, width = globalTheme.drawer.lineWidth) {
    this.clear()
    const ctx = this.canvas.current.getContext('2d')
    ctx.strokeStyle = color
    ctx.lineWidth = width

    ctx.beginPath()
    ctx.moveTo(this.state.start.x, this.state.start.y)
    ctx.lineTo(this.state.finish.x, this.state.finish.y)
    ctx.stroke()
    ctx.closePath()
  }

  clear() {
    const ctx = this.canvas.current.getContext('2d')
    ctx.clearRect(0, 0, this.canvas.current.width, this.canvas.current.height)

    this.setState({
      previous: { x: 0, y: 0 },
      current: { x: 0, y: 0 },
    })
  }

  render() {
    return <canvas ref={this.canvas} style={{ zIndex: 999 }} />
  }
}

Drawer.propTypes = {
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]).isRequired,
  changeMeasurement: PropTypes.func.isRequired,
}

export default Drawer



// WEBPACK FOOTER //
// ./src/components/Drawer/index.js